export const AUTH_START = 'AUTH_START';
export const AUTH_START2 = 'AUTH_START2';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const SIGNUP = 'SIGNUP';
export const AUTHERROR = 'AUTHERROR';
export const EMAIL_VERIFY = 'EMAIL_VERIFY';
// RYMIDR ACTIONS
export const ISLOADING = 'ISLOADING';
export const ERROR = 'ERROR';
export const GETCATEGORY = 'GETCATEGORY';
export const GETCATEGORYRYMINDR = 'GETCATEGORYRYMINDR';
export const GENERATEQRCODE = 'GENERATEQRCODE';
export const GETNOTIFICATION = 'GETNOTIFICATION';
export const ISSUCESS = 'ISSUCESS';
export const SUBCATEGORY = 'SUBCATEGORY';
export const GROUPLIST = 'GROUPLIST';
export const BUSINESSUSERS = 'BUSINESSUSERS';
export const CREATERYMINDR = 'CREATERYMINDR';
export const CREATETEMPLATE = 'CREATETEMPLATE';
export const CREATEFORMBUILDER = 'CREATEFORMBUILDER';
export const INVITEANDADDMOBILE = 'INVITEANDADDMOBILE';
export const GETUPCOMMINGRYMINDR = 'GETUPCOMMINGRYMINDR';
export const GETHISTORYRYMINDR = 'GETHISTORYRYMINDR';
export const GETHISTORYRYMINDRIDS = 'GETHISTORYRYMINDRIDS';
export const GETRYMINDRDETAILS = 'GETRYMINDRDETAILS';
export const DELETERYMINDR = 'DELETERYMINDR';
export const DELETERYMINDRHISTORY = 'DELETERYMINDRHISTORY';
export const RYMINDRACTION = 'RYMINDRACTION';
export const SUCCESS_MESSAGE_RYMINDR = 'SUCCESS_MESSAGE_RYMINDR';
export const SUCCESS_MESSAGE_FORM = 'SUCCESS_MESSAGE_FORM';
export const GETRESOURCECONTENT = 'GETRESOURCECONTENT';
export const STATUSDATA = 'STATUSDATA';
// DASHBOARD ACTIONS
export const GETUPCOMMINGRYMINDRDASHBOARD = 'GETUPCOMMINGRYMINDRDASHBOARD';
export const GETLIVEFEED = 'GETLIVEFEED';
export const GROUPDELETE = 'GROUPDELETE';
export const CONTACTDELETE = 'CONTACTDELETE';

//CONTACT ACTIONS
export const GETCONTACTLIST = 'GETCONTACTLIST';
export const GETGROUPLIST = 'GETGROUPLIST';
export const CONTACT_GROUP_MEMBER_LIST = 'CONTACT_GROUP_MEMBER_LIST';
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const GET_SEARCHED_USERS = 'GET_SEARCHED_USERS';
export const ADD_CONTACT = 'ADD_CONTACT';
export const RYMINDR_LIST = 'RYMINDR_LIST';
export const ADDNEWGROUP = 'ADDNEWGROUP';
export const ADDCONTACTTORYMINDR = 'ADDCONTACTTORYMINDR';
export const ADDCONTACTTOEVENT = 'ADDCONTACTTOEVENT';
export const CONTACT_ERROR = 'CONTACT_ERROR';
export const INVITE_USER = 'INVITE_USER';
export const EDITRYMINDR = 'EDITRYMINDR';

export const CONTACTERROR = 'CONTACTERROR';
export const CONTACTSUCESSMESSAGE = 'CONTACTSUCESSMESSAGE';
export const PENDINGREQUEST = 'PENDINGREQUEST';
export const USERCONTACTLIST = 'USERCONTACTLIST';


// ACCOUNT SETTING ACTIONS
export const ACISLOADING = 'ACISLOADING';
export const ACERROR = 'ACERROR';
export const SUCCESS_MESSAGE_ACCOUNT_SETTING = 'SUCCESS_MESSAGE_ACCOUNT_SETTING';
export const CHANGENOTIFICATIONSETTING = 'CHANGENOTIFICATIONSETTING';
export const MAKEDEFAULTCATEGORY = 'MAKEDEFAULTCATEGORY';
export const CHANGEPASSWORD = 'CHANGEPASSWORD';
export const UPDATEPROFILE = 'UPDATEPROFILE';
export const DELETEUSERACCOUNT = 'DELETEUSERACCOUNT';

// COMMENT ACTIONS
export const GETCOMMENT = 'GETCOMMENT';
export const ADDCOMMENT = 'ADDCOMMENT';
export const DELETECOMMENT = 'DELETECOMMENT';
export const COMMENTLIKE = 'COMMENTLIKE';

// NOTIFICATION ACTIONS
export const NOTIFICATIONREAD = 'NOTIFICATIONREAD';

export const SENDOTP = 'SENDOTP';
export const VERIFYOTP = 'VERIFYOTP';
export const RESETDATA = 'RESETDATA';
export const GETUSERDETAILS = 'GETUSERDETAILS';
export const GENRATEQRCODE = 'GENRATEQRCODE';
export const SUCCESS_MESSAGE_NOTIFICATION = 'SUCCESS_MESSAGE_NOTIFICATION';

// enent booking
// enent booking
export const BOOK_ISLOADING = 'BOOK_ISLOADING';
export const BOOK_ERROR = 'BOOK_ERROR';
export const BOOK_SUCESS = 'BOOK_SUCESS';
export const SUCCESS_MESSAGE_BOOK = 'SUCCESS_MESSAGE_BOOK';
export const BOOK_GROUPLIST = 'BOOK_GROUPLIST';
export const BOOK_BUSINESSUSERS = 'BOOK_BUSINESSUSERS';
export const BOOK_CREATERYMINDR = 'BOOK_CREATERYMINDR';
export const BOOK_UPDATERYMINDR = 'BOOK_UPDATERYMINDR';
export const FORM_BUILDER_LIST = 'FORM_BUILDER_LIST';
export const SUBMITTED_FORM_BY_CONTACT = 'SUBMITTED_FORM_BY_CONTACT';
export const FORM_TEMPLATES_LIST = 'FORM_TEMPLATES_LIST';
export const SUBMITTED_FORM_LIST = 'SUBMITTED_FORM_LIST';
export const BOOKLIST_ISLOADING = 'BOOKLIST_ISLOADING';
export const BOOKLIST_ERROR = 'BOOKLIST_ERROR';
export const BOOKLIST_SUCESS = 'BOOKLIST_SUCESS';
export const BOOKLIST_LIST = 'BOOKLIST_LIST';
export const EVENT_LIST = 'EVENT_LIST';
export const BOOKLIST_DELETE = 'BOOKLIST_DELETE';
export const BOOKLIST_DETAIL = 'BOOKLIST_DETAIL';
export const BOOK_CATEGORY = 'BOOK_CATEGORY';
export const STATUS_ACCEPT = 'STATUS_ACCEPT';
export const STATUS_PENDING = 'STATUS_PENDING';

//holiday-term
export const TERM_ISLOADING = 'TERM_ISLOADING';
export const TERM_ERROR = 'TERM_ERROR';
export const TERM_SUCESS = 'TERM_SUCESS';
export const Holiday_SUCESS = 'Holiday_SUCESS';

export const TERM_GROUPLIST = 'TERM_GROUPLIST';
export const TERM_CREATERYMINDR = 'TERM_CREATERYMINDR';
export const TERM_UPDATERYMINDR = 'TERM_UPDATERYMINDR';
export const TERM_LIST = 'TERM_LIST';
export const TERM_DELETE = 'TERM_DELETE';
export const TERM_DETAIL = 'TERM_DETAIL';
export const SUCCESS_TERM_HOLIDAY = 'SUCCESS_TERM_HOLIDAY';
export const TERMSTATUS = 'TERMSTATUS';
//end of -term-holiday

//MESSGAE CENTER
export const CREATEMESSAGECENTER = 'CREATEMESSAGECENTER';
export const GETRYMINDRLIST = 'GETRYMINDRLIST';
export const GETUSERRYMINDRLIST = 'GETUSERRYMINDRLIST';
export const GETMESSAGECENTERLIST = 'GETMESSAGECENTERLIST';
export const GETMESSAGECENTERLISTBYID = 'GETMESSAGECENTERLISTBYID';
export const GETMESSAGECENTERLISTAFTERDELETE = 'GETMESSAGECENTERLISTAFTERDELETE';
export const GETMESSAGECONTACTDETAIL = 'GETMESSAGECONTACTDETAIL';
export const GETRSSFEEDS = 'GETRSSFEEDS';
export const SUCCESS_MESSAGE_CENTER = 'SUCCESS_MESSAGE_CENTER';
export const MESSAGECENTERLISTCLEAR = 'MESSAGECENTERLISTCLEAR';

// LIVE CHAT
export const GET_USER_AND_GROUP_LIST = 'GET_USER_AND_GROUP_LIST';
export const CREATE_GROUP = 'CREATE_GROUP';
export const INIT_CHAT = 'INIT_CHAT';

// FORM BUILDER
export const DELETE_FORM_DATA = 'DELETE_FORM_DATA';
export const DELETE_TEMPLATE_DATA = 'DELETE_TEMPLATE_DATA';
export const FORMSTATUS = 'FORMSTATUS';